import React from 'react' ; 
import {motion} from 'framer-motion' ; 
import {v4} from 'uuid'; 
import {ReactComponent as Illustration} from '../../assets/svg/illustrations/under-construction_illustration.svg' ; 



export default function UnderConstruction() {

    return (
        <motion.div 
            key = {v4()}
            exit = {{scale : 0}}
            initial = {{scale : 0}}
            animate = {{scale : 1}}
            className='underconstruction'
        >
            <Illustration />
            <p>Page en construction....</p>
        </motion.div>
    )
}

